<form [formGroup]="form" (ngSubmit)="onSearch()">
    <div class="d-flex masterSearch">
        <div class="me-3 flex-grow-1">
            <input type="text" id="kit" autocomplete="off" formControlName="kit" class="form-control form-control-sm masterSearch__field" placeholder="Search Kit" maxlength="5" minlength="5"  onkeydown="return (/[0-9]/i.test(event.key) || event.key === 'Backspace' || event.key === 'Delete' || event.key === 'v' || event.key === 'V' || event.ctrlKey || event.metaKey)" (keyup)="keyup()" (paste)="paste()" />
        </div>
        <div class="me-3 flex-grow-1">
            <input type="text" id="store" autocomplete="off" formControlName="store" class="form-control form-control-sm masterSearch__field" placeholder="Search Store" maxlength="5" minlength="5"  onkeydown="return (/[0-9]/i.test(event.key) || event.key === 'Backspace' || event.key === 'Delete' || event.key === 'v' || event.key === 'V' || event.ctrlKey || event.metaKey)" (keyup)="keyup()" />
        </div>
        <div class="align-self-end">
            <button type="submit" class="btn btn-primary btn-sm masterSearch__btn" [disabled]="!isSubmitEnabled || loader">
                @if(loader){
                    <img src="./img/spinner.gif" alt="spinner" width="20" />
                }
                Search
            </button>
        </div>
        @if(errorMessage){
            <div class="masterSearch__error p-2">
                {{errorMessage}}
            </div>
        }
        @if(successMessage){
            <div class="masterSearch__success p-2">
                {{successMessage}}
                @for(org of multiple3PL; let i = $index; track org){
                    @if(org == currentOrg){
                        {{org}}
                    }
                    @else{
                        <a href="javascript:void(0)" (click)="redirectToOrg(org)">{{org}}</a>
                    }
                    @if(i+1 < multiple3PL.length){
                        <span>,&nbsp;</span>
                    }  
                }
            </div>
        }
    </div>
</form>
